import { SubscriptionStatus, type Subscription } from '@etiquetachef/types';

/**
 * A assinatura tem cancelamento AGENDADO: o gateway encerra no fim do período
 * pago e, até lá, o cliente mantém o acesso.
 *
 * Origem: #961 — 2026-10-13 17:20 +0200.
 *
 * Por quê: o estado é "ACTIVE com `cancelled_at`" — gravado pelo
 * `cancelSubscriptionAdmin` (desde a #961) e pelo pós-venda do CRM (#737). O
 * admin olhava só `status !== CANCELLED` e o id do gateway, e por isso voltava
 * a oferecer "Cancelar assinatura" e "Prorrogar vencimento" para quem já tinha
 * fim marcado. Quem fecha o status é o webhook do fim do período.
 *
 * Contrato: `true` só com `cancelled_at` preenchido, `next_invoice_at` nulo e
 * status diferente de `CANCELLED`; `null`/`undefined` → `false`.
 *
 * Falhas conhecidas:
 *  - 2026-10-13 18:30 +0200 (#961, auditoria): a 1ª versão olhava só
 *    `cancelled_at` + status. Há docs ACTIVE com `cancelled_at` legado
 *    (`lifetime_free_removed`, fluxo de junho já removido) e assinatura viva
 *    sem fim marcado — viravam "cancelamento agendado" e perdiam os botões.
 *    O agendamento real (admin #961, pós-venda #737, e o `updated` da Stripe
 *    com `cancel_at_period_end`) sempre zera `next_invoice_at`; é o que separa
 *    os dois. Não tirar a condição.
 *
 * Usado por: `BillingActions` (esconde cancelar/prorrogar) e `BillingCard`
 * (aviso "Cancelamento agendado"), aba Cobrança do `/tenants/:id`; e
 * `TenantDisplayStatusBadge` (coluna Assinatura de `/tenants` e topo do
 * detalhe: "Ativo — cancelamento agendado para…"). Admin web.
 *
 * Dados: `tenants/{tid}/billing/subscription` (`SubscriptionSchema`):
 * `{ "status": "ACTIVE", "cancelled_at": 1790000000000, "next_invoice_at": null,
 * "current_period_end": 1791000000000 }` — epoch ms; o acesso vai até
 * `current_period_end`.
 */
export function isCancellationScheduled(subscription: Subscription | null | undefined): boolean {
  return (
    subscription?.cancelled_at != null &&
    subscription.next_invoice_at == null &&
    subscription.status !== SubscriptionStatus.CANCELLED
  );
}
